module.exports = __webpack_public_path__ + "img/m3.f28168a.jpg";